//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import UserModel from '@/models/General/GUser'

//
export default [
  {
    name: 'g_branch_office_id',
    props: {
      itemText: 'name',
      itemValue: 'id',
      noObject: true,
      label: 'Sucursal',
      model: BranchOfficeModel,
      paramSearch: 'name',
    },
    type: 'autocomplete-model'
  },
  {
    name: 'g_user_id',
    props: {
      itemText: 'full_name',
      itemValue: 'id',
      label: 'Empleado',
      model: UserModel,
      noObject: true,
    },
    type: 'autocomplete-model'
  },
]